import React, { useEffect, useState } from "react";
import UserService from "Services/http/endpoints/user/UserService";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import Translator from "Languages/Utility/Translator";
import {
  Checkbox,
  DialogActions,
  Divider,
  FormControlLabel,
  Grid,
  Switch,
} from "@material-ui/core";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import { useSetState } from "Helpers/Hooks";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import showNotify from "Helpers/Notify";
import { Alert } from "@material-ui/lab";
import MuiButton from "Components/MuiButton/MuiButton";
import { ReactSVG } from "react-svg";
import UserAccessIcon from "Assets/svg/icon/UserAccess_nv.svg";
import infoIcon from "Assets/svg/icon/info.svg";
import { useTranslation } from "react-i18next";

function UserAccess({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [controls, setControls] = useSetState({});
  const [statusAll, setStatusAll] = useState(false);

  const switchChange = async (e) => {
    setLoading(true);
    Object.keys(controls).map((key) => {
      setControls({[key] : {
        ...controls[key],
        totalStatus: e.target.checked,
        items: Object.keys(controls[key].items).map((inner) => {
          return {
            ...controls[key].items[inner],
            value: e.target.checked,
          };
        }),
      }});
    });
    setLoading(false);
  };

  const handleDialog = () => {
    setShowDialog(!showDialog);
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({
      [name]: {
        items: items,
        totalStatus: items.map((i) => i.value).every(Boolean),
        indeterminate: !items.map((i) => i.value).every(Boolean),
      },
    });
  };

  const onEnter = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        KeySelect: row.Key,
      };
      const response = await UserService.getAccessData(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const dt = response.data.Value;
        for (let i = 0; i < dt.length; i++) {
          const items = dt[i].ListAction.map((item) => {
            return {
              value: item.Check,
              label: t(item.NameAction),
              key: item.Id,
            };
          });
          setControls({
            [dt[i].NameForm]: {
              type: "checkbox",
              items: items,
              open: false,
              totalStatus: items.map((i) => i.value).every(Boolean),
              indeterminate: !items.map((i) => i.value).every(Boolean),
            },
          });
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onFinish = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      let ids = [];
      Object.keys(controls).map((key) => {
        let arr = controls[key].items.map((item) => {
          if (item.value) {
            return item.key;
          } else return null;
        });
        arr = arr.filter((x) => x);

        ids = ids.concat(arr);
      });
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        KeySelect: row.Key,
        ListIdAction: ids,
      };
      const response = await UserService.postAccessID(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: t("mission_accomplished"),
          customClass: "success",
        });
      }
      handleDialog();
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const toggleEexpandRow = (key) => {
    setControls({ [key]: { open: !controls[key].open } });
  };

  const onChangeIndeterminate = (e, name) => {
    if (!controls[name].open) {
      setControls({ [name]: { open: true } });
    } else {
      const items = controls[name].items.map((i) => {
        return { ...i, value: e.currentTarget.checked };
      });
      setControls({
        [name]: {
          items: items,
          totalStatus: items.map((i) => i.value).every(Boolean),
          indeterminate: !items.map((i) => i.value).every(Boolean),
        },
      });
    }
  };

  useEffect(() => {
    try {
      if (!loading && controls.length !== 0) {
        setStatusAll(
          Object.keys(controls)
            .map((items) => {
              return controls[items].totalStatus;
            })
            .every(Boolean)
        );
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  }, [loading, controls]);

  return (
    <>
      <ActionFormatter
        title={<Translator id="setAccessLevel" />}
        icon={<ReactSVG src={UserAccessIcon} />}
        className="warning-fill"
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader havebtn">
            <p>
              <Translator id="EditUserAccess" />
            </p>
            <div className="d-flex justify-content-between">
              <FormControlLabel
                className="flex-row-reverse m-0"
                control={
                  <Switch
                  className={`switcher ${direction}`}
                    color="primary"
                    checked={statusAll}
                    onClick={switchChange}
                  />
                }
                label={t("selectAll")}
              />
            </div>
          </div>
          <DialogContent
            className={`header-btn ${
              direction === "rtl" ? "text-right" : "text-left"
            }`}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  variant="outlined"
                  className="d-flex flex-row justify-content-start align-items-center"
                  icon={<ReactSVG src={infoIcon} />}
                >
                  <div className="w-100 d-flex flex-column flex-sm-row g-3">
                    <span>{`${t("name")} : ${row.DisplayName}`}</span>
                    <span className="d-none d-sm-block">{"|"}</span>
                    <span>{`${t("role")} : ${row.NameStype}`}</span>
                  </div>
                </Alert>
              </Grid>
              <Grid item xs={12} className="access-show-tree-view">
                {Object.keys(controls).map((key) => {
                  return (
                    <>
                      <div className="item-group">
                        <div className="item-label">
                          <Checkbox
                            checked={controls[key].totalStatus}
                            onChange={(e) => onChangeIndeterminate(e, key)}
                            indeterminate={controls[key].indeterminate}
                          />
                          <div onClick={() => toggleEexpandRow(key)}>
                            <Translator id={key} />
                          </div>
                        </div>
                        {controls[key].open && (
                          <div className="item-checkbox">
                            <MuiCheckBoxGroup
                              name={key}
                              items={controls[key].items}
                              onChange={onChangeCheckbox}
                              className="user-access"
                            />
                          </div>
                        )}
                      </div>
                      <Divider />
                    </>
                  );
                })}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default UserAccess;
